// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1yl_o","titles-wrapper":"_1Otlp","titlesWrapper":"_1Otlp","description":"_2AHi6","section-tabs":"dBrVA","sectionTabs":"dBrVA"};